import type { ProductAccordionsProps } from 'components/productdetail/accordions/ProductAccordions';
import { FEATURE_PDP_TECH_SPECS } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { HighlightsAccordion } from 'components/productdetail/accordions/HighlightsAccordion';
import { ItemInformationAccordion } from 'components/productdetail/accordions/ItemInformationAccordion';
import { SizeChartAccordion } from 'components/productdetail/accordions/SizeChartAccordion';
import { TechSpecsAccordion } from 'components/productdetail/accordions/TechSpecsAccordion';

export const ProductAccordionList = ({ colorId, product, productId, openSizeChartModal }: ProductAccordionsProps) => {
  const { isEnrolled: isPdpTechSpecs } = useIsEnrolledInVariant(FEATURE_PDP_TECH_SPECS);
  const { detail: productDetail } = product;

  return (
    <div data-test-id="productAccordionListSections">
      {isPdpTechSpecs && <TechSpecsAccordion colorId={colorId} productDetail={productDetail} />}
      <ItemInformationAccordion product={product} productId={productId} />
      <SizeChartAccordion productDetail={productDetail} openSizeChartModal={openSizeChartModal} />
      {!isPdpTechSpecs && <HighlightsAccordion colorId={colorId} productDetail={productDetail} />}
    </div>
  );
};
